module.exports = __webpack_public_path__ + "static/media/tear-pads.acb54c70.png";